import { BRAND } from '../generated/brand';
import { getCompanyBrand } from './company-brand';
import { currentLang, translate, TextKey } from '../i18n';

/** Título de la pestaña: "<texto en el idioma de la persona> - <marca>". */
export const setPageTitle = (key: TextKey) => {
  document.title = `${translate(currentLang(), key)} - ${getCompanyBrand()?.name ?? BRAND.displayName}`;
};
